import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";

import {
  SelectPlanById,
  fetchPlanPriceByIdAsync,
} from "../PriceSection/PriceSectionSlice";
import { CheckIcon } from "@heroicons/react/20/solid";

const includedFeatures = [
  "Free gym Bag",
  "Member resources",
  "Entry to annual conference",
  "Official member t-shirt",
];

function PlanCheckout() {
  const dispatch = useDispatch();
  const params = useParams();

  const plan = useSelector(SelectPlanById);

  useEffect(() => {
    dispatch(fetchPlanPriceByIdAsync(params.id));
  }, [dispatch, params.id]);
  const phoneNumber = "9382732250"; // Replace with the recipient's phone number
  const message = "Hello, this is a pre-filled message!"; // Replace with your message

  const handleWhatsAppClick = () => {
    const url = `whatsapp://send?phone=${phoneNumber}&text=${encodeURIComponent(
      message
    )}`;
    window.open(url);
  };
  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl sm:text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            This Is Our Plan Details
          </h2>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            More Information Click Whatapp button And contact Us
            <button onClick={handleWhatsAppClick}>
              <button className="bg-green-500 p-2 rounded-lg text-white">
                {" "}
                WhatsApp
              </button>
            </button>
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none">
          <div className="p-8 sm:p-10 lg:flex-auto">
            <h3 className="text-2xl font-bold tracking-tight text-gray-900">
              {plan?.title}
            </h3>
            <p className="mt-6 text-base leading-7 text-gray-600">
              Fitness Redefined, Results Guaranteed.
            </p>
            <div className="mt-10 flex items-center gap-x-4">
              <h4 className="flex-none text-sm font-semibold leading-6 text-indigo-600">
                What’s included
              </h4>
              <div className="h-px flex-auto bg-gray-100" />
            </div>
            <ul
              role="list"
              className="mt-8 grid grid-cols-1 gap-4 text-sm leading-6 text-gray-600 sm:grid-cols-2 sm:gap-6"
            >
              {includedFeatures.map((feature) => (
                <li key={feature} className="flex gap-x-3">
                  <CheckIcon
                    className="h-6 w-5 flex-none text-indigo-600"
                    aria-hidden="true"
                  />
                  {feature}
                </li>
              ))}
            </ul>
          </div>
          <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:flex-shrink-0">
            <div className="rounded-2xl bg-gray-50 py-10 text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-16">
              {/* Product info */}
              <div className="pt-1">
                <nav aria-label="Breadcrumb">
                  {plan &&
                    plan.breadcrumbs &&
                    plan.breadcrumbs.map((breadcrumb) => (
                      <li key={breadcrumb.id}>
                        <div className="flex items-center">
                          <a
                            href={breadcrumb.href}
                            className="mr-2 text-sm font-medium text-gray-900"
                          >
                            {breadcrumb.name}
                          </a>
                          <svg
                            width={16}
                            height={20}
                            viewBox="0 0 16 20"
                            fill="currentColor"
                            aria-hidden="true"
                            className="h-5 w-4 text-gray-300"
                          >
                            <path d="M5.697 4.34L8.98 16.532h1.327L7.025 4.341H5.697z" />
                          </svg>
                        </div>
                      </li>
                    ))}
                  <li className="text-sm">
                    <a
                      href={plan?.currentLink} // Replace with your route logic
                      aria-current="page"
                      className="font-medium text-gray-500 hover:text-gray-600"
                    >
                      {plan?.title}
                    </a>
                  </li>
                </nav>

                {/* Product info */}
                <div>
                  <div className="lg:col-span-2 lg:border-r lg:border-gray-200 lg:pr-8">
                    <h1 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
                      {plan?.title}
                    </h1>
                    <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-sm lg:flex-shrink-0">
                      <div className="rounded-2xl bg-blue-600 py-10 text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-16">
                        <div key={plan?.id} className="mx-auto max-w-xs px-8">
                          <p className="text-base font-semibold text-gray-50">
                            {plan?.title}
                          </p>
                          <p className="mt-6 flex items-baseline justify-center gap-x-2">
                            <span className="text-5xl font-bold tracking-tight text-white">
                              {plan?.price}
                            </span>
                            <span className="text-sm font-semibold leading-6 tracking-wide text-gray-50">
                              RS
                            </span>
                          </p>
                          <div className="flex justify-center items-center text-center">
                            <p className="text-base font-semibold text-gray-50">
                              1-{plan?.highlight1}
                            </p>
                          </div>
                          <div className="flex justify-center items-center text-center">
                            <p className="text-base font-semibold text-gray-50">
                              2-{plan?.highlight2}
                            </p>{" "}
                          </div>
                          <div className="flex justify-center items-center text-center">
                            <p className="text-base font-semibold text-gray-50">
                              3-{plan?.highlight3}
                            </p>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlanCheckout;
